const origin = 'dialog';

export const SHOW_DIALOG = `${origin}/show`;
export const HIDE_DIALOG = `${origin}/hide`;
